import { render, staticRenderFns } from "./CreateContactAction.vue?vue&type=template&id=325afd85"
import script from "./CreateContactAction.vue?vue&type=script&lang=js"
export * from "./CreateContactAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports